import { render, staticRenderFns } from "./account-features.vue?vue&type=template&id=5a44692f&scoped=true&"
import script from "./account-features.vue?vue&type=script&lang=js&"
export * from "./account-features.vue?vue&type=script&lang=js&"
import style0 from "./account-features.vue?vue&type=style&index=0&id=5a44692f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a44692f",
  null
  
)

export default component.exports